import { msg } from '@lingui/core/macro'
import { useLingui } from '@lingui/react'

export type InventoryListItem = {
  quantity?: number | null
  item: {
    id: number
    name?: string | null
    displayUnit?: string | null
  }
}

/** Inventory section: consolidated "what to load" list across the assignment's orders. */
export const InventoryList = ({
  inventory,
}: { inventory: InventoryListItem[] }) => {
  const { _ } = useLingui()
  if (inventory.length === 0) return null

  return (
    <div className='assignment-detail__hero-block'>
      <div className='assignment-detail__section-title'>
        {_(msg`Inventory`)}
      </div>
      <ul className='assignment-detail__inventory-list'>
        {inventory.map(({ quantity, item }) => (
          <li key={item.id}>
            {[
              item.name,
              quantity ? `${quantity}${item.displayUnit || 'x'}` : null,
            ]
              .filter(Boolean)
              .join(' - ')}
          </li>
        ))}
      </ul>
    </div>
  )
}
